import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { setCurrentUser } from "../../redux/user/user.actions";
import { setCurrentDistro } from "../../redux/distro/distro.actions";
import { getApiUrl } from "../../utils/api";

const redemptions = new Map();

const redeemCode = (code) => {
    if (!redemptions.has(code)) {
        redemptions.set(code, fetch(`${getApiUrl()}/sso/consume`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code }),
        }).then(response => {
            if (!response.ok) {
                throw new Error(`consume failed: ${response.status}`);
            }
            return response.json();
        }));
    }
    return redemptions.get(code);
};

const SsoLandingPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [error, setError] = useState(null);

    useEffect(() => {
        const code = new URLSearchParams(location.search).get("code");
        if (!code) {
            setError("This link is invalid or has expired.");
            return;
        }

        let cancelled = false;

        const redeem = async () => {
            try {
                const session = await redeemCode(code);
                if (cancelled) return;

                dispatch(setCurrentUser(session));
                dispatch(setCurrentDistro(session.role === "owner"
                    ? session.landingDistroId || session.distros?.[0]?.id || null
                    : null));
                history.replace(session.landingRoute || "/user/profile");
            } catch (e) {
                if (!cancelled) setError("This link is invalid or has expired.");
            }
        };

        redeem();

        return () => {
            cancelled = true;
        };
    }, [location.search, dispatch, history]);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center px-4">
                <div className="text-center">
                    <h1 className="text-xl font-semibold text-gray-800">{error}</h1>
                    <p className="mt-2 text-gray-500">Return to the ops portal and open the advisor view again.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center">
            <Loader2 className="animate-spin text-gray-400" size={32} />
        </div>
    );
};

export default SsoLandingPage;
